/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as RedirectsRouteImport } from './routes/_redirects'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppApiKeysRouteImport } from './routes/_app/api-keys'
import { Route as AppDevicesRouteImport } from './routes/_app/devices'
import { Route as AppImpactsRouteImport } from './routes/_app/impacts'
import { Route as AppMeasurementsRouteImport } from './routes/_app/measurements'
import { Route as AppSmpRouteRouteImport } from './routes/_app/smp/route'
import { Route as AppSubscriptionRouteImport } from './routes/_app/subscription'
import { Route as AppUsersRouteRouteImport } from './routes/_app/users/route'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as RedirectsAssetRouteImport } from './routes/_redirects/asset'
import { Route as AppAlertsAddRouteImport } from './routes/_app/alerts.add'
import { Route as AppAssetsAddRouteImport } from './routes/_app/assets.add'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices.index'
import { Route as AppDevicesIdRouteImport } from './routes/_app/devices.$id'
import { Route as AppDevicesAddRouteImport } from './routes/_app/devices.add'
import { Route as AppImpactsIndexRouteImport } from './routes/_app/impacts.index'
import { Route as AppImpactsIdRouteImport } from './routes/_app/impacts.$id'
import { Route as AppMIndexRouteImport } from './routes/_app/m/index'
import { Route as AppMMobileRouteImport } from './routes/_app/m/_mobile'
import { Route as AppMeasurementsIndexRouteImport } from './routes/_app/measurements.index'
import { Route as AppMeasurementsIdRouteImport } from './routes/_app/measurements.$id'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports.index'
import { Route as AppReportsAddRouteImport } from './routes/_app/reports.add'
import { Route as AppReportsCsvRouteImport } from './routes/_app/reports.csv'
import { Route as AppSmpAccountsRouteImport } from './routes/_app/smp/accounts'
import { Route as AppSmpServiceMapRouteImport } from './routes/_app/smp/serviceMap'
import { Route as AppSmpWebRelaysRouteImport } from './routes/_app/smp/webRelays'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users/$id'
import { Route as AppUsersAddRouteImport } from './routes/_app/users/add'
import { Route as AppWindAddRouteImport } from './routes/_app/wind.add'
import { Route as PublicAuthErrorRouteImport } from './routes/_public/auth.error'
import { Route as PublicOptinSecretRouteImport } from './routes/_public/optin.$secret'
import { Route as AppAssetsIdEditRouteImport } from './routes/_app/assets.$id_.edit'
import { Route as AppDevicesIdEditRouteImport } from './routes/_app/devices.$id_.edit'
import { Route as AppMMobileLocationsRouteImport } from './routes/_app/m/_mobile.locations'
import { Route as AppMMobileMapRouteImport } from './routes/_app/m/_mobile.map'
import { Route as AppMMobilePreferencesRouteImport } from './routes/_app/m/_mobile.preferences'
import { Route as AppReportsHailIdRouteImport } from './routes/_app/reports.hail.$id'
import { Route as AppReportsLightningIdRouteImport } from './routes/_app/reports.lightning.$id'
import { Route as AppSmpAccountsCustomerIdRouteImport } from './routes/_app/smp/accounts/$customerId'
import { Route as AppSmpServiceMapIndexRouteImport } from './routes/_app/smp/serviceMap/index'
import { Route as AppSmpWebhooksCreateRouteImport } from './routes/_app/smp/webhooks/create'
import { Route as AppSmpWebhooksChar123WebhookIdChar125RouteImport } from './routes/_app/smp/webhooks/{-$webhookId}'
import { Route as AppUsersListChar123IdChar125RouteImport } from './routes/_app/users/list.{-$id}'
import { Route as AppAlertsVrnProtectionTypeEditRouteImport } from './routes/_app/alerts_.$vrn.$protectionType.edit'
import { Route as AppSmpAccountsCustomerIdAddRouteImport } from './routes/_app/smp/accounts/$customerId.add'
import { Route as AppSmpServiceMapDeviceDeviceIdRouteImport } from './routes/_app/smp/serviceMap/device.$deviceId'
import { Route as AppSmpWebhooksWebhookIdEditRouteImport } from './routes/_app/smp/webhooks/$webhookId.edit'
import { Route as AppSmpAccountsCustomerIdSubscriptionIdEditRouteImport } from './routes/_app/smp/accounts/$customerId.$subscriptionId.edit'
import { Route as AppSmpWebhooksWebhookIdSecretsCreateRouteImport } from './routes/_app/smp/webhooks/$webhookId.secrets.create'
import { Route as AppSmpWebhooksWebhookIdSecretsSecretIdEditRouteImport } from './routes/_app/smp/webhooks/$webhookId.secrets.$secretId.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectsRoute = RedirectsRouteImport.update({
  id: '/_redirects',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppApiKeysRoute = AppApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesRoute = AppDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppImpactsRoute = AppImpactsRouteImport.update({
  id: '/impacts',
  path: '/impacts',
  getParentRoute: () => AppRoute,
} as any)
const AppMeasurementsRoute = AppMeasurementsRouteImport.update({
  id: '/measurements',
  path: '/measurements',
  getParentRoute: () => AppRoute,
} as any)
const AppSmpRouteRoute = AppSmpRouteRouteImport.update({
  id: '/smp',
  path: '/smp',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscriptionRoute = AppSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectsAssetRoute = RedirectsAssetRouteImport.update({
  id: '/asset',
  path: '/asset',
  getParentRoute: () => RedirectsRoute,
} as any)
const AppAlertsAddRoute = AppAlertsAddRouteImport.update({
  id: '/alerts/add',
  path: '/alerts/add',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsAddRoute = AppAssetsAddRouteImport.update({
  id: '/assets/add',
  path: '/assets/add',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppDevicesIdRoute = AppDevicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppDevicesAddRoute = AppDevicesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppImpactsIndexRoute = AppImpactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppImpactsRoute,
} as any)
const AppImpactsIdRoute = AppImpactsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppImpactsRoute,
} as any)
const AppMIndexRoute = AppMIndexRouteImport.update({
  id: '/m/',
  path: '/m/',
  getParentRoute: () => AppRoute,
} as any)
const AppMMobileRoute = AppMMobileRouteImport.update({
  id: '/m/_mobile',
  path: '/m',
  getParentRoute: () => AppRoute,
} as any)
const AppMeasurementsIndexRoute = AppMeasurementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMeasurementsRoute,
} as any)
const AppMeasurementsIdRoute = AppMeasurementsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMeasurementsRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsAddRoute = AppReportsAddRouteImport.update({
  id: '/reports/add',
  path: '/reports/add',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsCsvRoute = AppReportsCsvRouteImport.update({
  id: '/reports/csv',
  path: '/reports/csv',
  getParentRoute: () => AppRoute,
} as any)
const AppSmpAccountsRoute = AppSmpAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppSmpRouteRoute,
} as any)
const AppSmpServiceMapRoute = AppSmpServiceMapRouteImport.update({
  id: '/serviceMap',
  path: '/serviceMap',
  getParentRoute: () => AppSmpRouteRoute,
} as any)
const AppSmpWebRelaysRoute = AppSmpWebRelaysRouteImport.update({
  id: '/webRelays',
  path: '/webRelays',
  getParentRoute: () => AppSmpRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersAddRoute = AppUsersAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppWindAddRoute = AppWindAddRouteImport.update({
  id: '/wind/add',
  path: '/wind/add',
  getParentRoute: () => AppRoute,
} as any)
const PublicAuthErrorRoute = PublicAuthErrorRouteImport.update({
  id: '/_public/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOptinSecretRoute = PublicOptinSecretRouteImport.update({
  id: '/_public/optin/$secret',
  path: '/optin/$secret',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAssetsIdEditRoute = AppAssetsIdEditRouteImport.update({
  id: '/assets/$id_/edit',
  path: '/assets/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIdEditRoute = AppDevicesIdEditRouteImport.update({
  id: '/$id_/edit',
  path: '/$id/edit',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppMMobileLocationsRoute = AppMMobileLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppMMobileRoute,
} as any)
const AppMMobileMapRoute = AppMMobileMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppMMobileRoute,
} as any)
const AppMMobilePreferencesRoute = AppMMobilePreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppMMobileRoute,
} as any)
const AppReportsHailIdRoute = AppReportsHailIdRouteImport.update({
  id: '/reports/hail/$id',
  path: '/reports/hail/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsLightningIdRoute = AppReportsLightningIdRouteImport.update({
  id: '/reports/lightning/$id',
  path: '/reports/lightning/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSmpAccountsCustomerIdRoute =
  AppSmpAccountsCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AppSmpAccountsRoute,
  } as any)
const AppSmpServiceMapIndexRoute = AppSmpServiceMapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSmpServiceMapRoute,
} as any)
const AppSmpWebhooksCreateRoute = AppSmpWebhooksCreateRouteImport.update({
  id: '/webhooks/create',
  path: '/webhooks/create',
  getParentRoute: () => AppSmpRouteRoute,
} as any)
const AppSmpWebhooksChar123WebhookIdChar125Route =
  AppSmpWebhooksChar123WebhookIdChar125RouteImport.update({
    id: '/webhooks/{-$webhookId}',
    path: '/webhooks/{-$webhookId}',
    getParentRoute: () => AppSmpRouteRoute,
  } as any)
const AppUsersListChar123IdChar125Route =
  AppUsersListChar123IdChar125RouteImport.update({
    id: '/list/{-$id}',
    path: '/list/{-$id}',
    getParentRoute: () => AppUsersRouteRoute,
  } as any)
const AppAlertsVrnProtectionTypeEditRoute =
  AppAlertsVrnProtectionTypeEditRouteImport.update({
    id: '/alerts_/$vrn/$protectionType/edit',
    path: '/alerts/$vrn/$protectionType/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppSmpAccountsCustomerIdAddRoute =
  AppSmpAccountsCustomerIdAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppSmpAccountsCustomerIdRoute,
  } as any)
const AppSmpServiceMapDeviceDeviceIdRoute =
  AppSmpServiceMapDeviceDeviceIdRouteImport.update({
    id: '/device/$deviceId',
    path: '/device/$deviceId',
    getParentRoute: () => AppSmpServiceMapRoute,
  } as any)
const AppSmpWebhooksWebhookIdEditRoute =
  AppSmpWebhooksWebhookIdEditRouteImport.update({
    id: '/webhooks/$webhookId/edit',
    path: '/webhooks/$webhookId/edit',
    getParentRoute: () => AppSmpRouteRoute,
  } as any)
const AppSmpAccountsCustomerIdSubscriptionIdEditRoute =
  AppSmpAccountsCustomerIdSubscriptionIdEditRouteImport.update({
    id: '/$subscriptionId/edit',
    path: '/$subscriptionId/edit',
    getParentRoute: () => AppSmpAccountsCustomerIdRoute,
  } as any)
const AppSmpWebhooksWebhookIdSecretsCreateRoute =
  AppSmpWebhooksWebhookIdSecretsCreateRouteImport.update({
    id: '/webhooks/$webhookId/secrets/create',
    path: '/webhooks/$webhookId/secrets/create',
    getParentRoute: () => AppSmpRouteRoute,
  } as any)
const AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute =
  AppSmpWebhooksWebhookIdSecretsSecretIdEditRouteImport.update({
    id: '/webhooks/$webhookId/secrets/$secretId/edit',
    path: '/webhooks/$webhookId/secrets/$secretId/edit',
    getParentRoute: () => AppSmpRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/smp': typeof AppSmpRouteRouteWithChildren
  '/users': typeof AppUsersRouteRouteWithChildren
  '/api-keys': typeof AppApiKeysRoute
  '/devices': typeof AppDevicesRouteWithChildren
  '/impacts': typeof AppImpactsRouteWithChildren
  '/measurements': typeof AppMeasurementsRouteWithChildren
  '/subscription': typeof AppSubscriptionRoute
  '/login': typeof PublicLoginRoute
  '/asset': typeof RedirectsAssetRoute
  '/alerts/add': typeof AppAlertsAddRoute
  '/assets/add': typeof AppAssetsAddRoute
  '/devices/$id': typeof AppDevicesIdRoute
  '/devices/add': typeof AppDevicesAddRoute
  '/impacts/$id': typeof AppImpactsIdRoute
  '/m': typeof AppMMobileRouteWithChildren
  '/measurements/$id': typeof AppMeasurementsIdRoute
  '/reports/add': typeof AppReportsAddRoute
  '/reports/csv': typeof AppReportsCsvRoute
  '/smp/accounts': typeof AppSmpAccountsRouteWithChildren
  '/smp/serviceMap': typeof AppSmpServiceMapRouteWithChildren
  '/smp/webRelays': typeof AppSmpWebRelaysRoute
  '/users/$id': typeof AppUsersIdRoute
  '/users/add': typeof AppUsersAddRoute
  '/wind/add': typeof AppWindAddRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/optin/$secret': typeof PublicOptinSecretRoute
  '/devices/': typeof AppDevicesIndexRoute
  '/impacts/': typeof AppImpactsIndexRoute
  '/m/': typeof AppMIndexRoute
  '/measurements/': typeof AppMeasurementsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/assets/$id/edit': typeof AppAssetsIdEditRoute
  '/devices/$id/edit': typeof AppDevicesIdEditRoute
  '/m/locations': typeof AppMMobileLocationsRoute
  '/m/map': typeof AppMMobileMapRoute
  '/m/preferences': typeof AppMMobilePreferencesRoute
  '/reports/hail/$id': typeof AppReportsHailIdRoute
  '/reports/lightning/$id': typeof AppReportsLightningIdRoute
  '/smp/accounts/$customerId': typeof AppSmpAccountsCustomerIdRouteWithChildren
  '/smp/webhooks/create': typeof AppSmpWebhooksCreateRoute
  '/smp/webhooks/{-$webhookId}': typeof AppSmpWebhooksChar123WebhookIdChar125Route
  '/users/list/{-$id}': typeof AppUsersListChar123IdChar125Route
  '/smp/serviceMap/': typeof AppSmpServiceMapIndexRoute
  '/alerts/$vrn/$protectionType/edit': typeof AppAlertsVrnProtectionTypeEditRoute
  '/smp/accounts/$customerId/add': typeof AppSmpAccountsCustomerIdAddRoute
  '/smp/serviceMap/device/$deviceId': typeof AppSmpServiceMapDeviceDeviceIdRoute
  '/smp/webhooks/$webhookId/edit': typeof AppSmpWebhooksWebhookIdEditRoute
  '/smp/accounts/$customerId/$subscriptionId/edit': typeof AppSmpAccountsCustomerIdSubscriptionIdEditRoute
  '/smp/webhooks/$webhookId/secrets/create': typeof AppSmpWebhooksWebhookIdSecretsCreateRoute
  '/smp/webhooks/$webhookId/secrets/$secretId/edit': typeof AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/smp': typeof AppSmpRouteRouteWithChildren
  '/api-keys': typeof AppApiKeysRoute
  '/subscription': typeof AppSubscriptionRoute
  '/login': typeof PublicLoginRoute
  '/asset': typeof RedirectsAssetRoute
  '/alerts/add': typeof AppAlertsAddRoute
  '/assets/add': typeof AppAssetsAddRoute
  '/devices/$id': typeof AppDevicesIdRoute
  '/devices/add': typeof AppDevicesAddRoute
  '/impacts/$id': typeof AppImpactsIdRoute
  '/m': typeof AppMIndexRoute
  '/measurements/$id': typeof AppMeasurementsIdRoute
  '/reports/add': typeof AppReportsAddRoute
  '/reports/csv': typeof AppReportsCsvRoute
  '/smp/accounts': typeof AppSmpAccountsRouteWithChildren
  '/smp/webRelays': typeof AppSmpWebRelaysRoute
  '/users/$id': typeof AppUsersIdRoute
  '/users/add': typeof AppUsersAddRoute
  '/wind/add': typeof AppWindAddRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/optin/$secret': typeof PublicOptinSecretRoute
  '/devices': typeof AppDevicesIndexRoute
  '/impacts': typeof AppImpactsIndexRoute
  '/measurements': typeof AppMeasurementsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/assets/$id/edit': typeof AppAssetsIdEditRoute
  '/devices/$id/edit': typeof AppDevicesIdEditRoute
  '/m/locations': typeof AppMMobileLocationsRoute
  '/m/map': typeof AppMMobileMapRoute
  '/m/preferences': typeof AppMMobilePreferencesRoute
  '/reports/hail/$id': typeof AppReportsHailIdRoute
  '/reports/lightning/$id': typeof AppReportsLightningIdRoute
  '/smp/accounts/$customerId': typeof AppSmpAccountsCustomerIdRouteWithChildren
  '/smp/webhooks/create': typeof AppSmpWebhooksCreateRoute
  '/smp/webhooks/{-$webhookId}': typeof AppSmpWebhooksChar123WebhookIdChar125Route
  '/users/list/{-$id}': typeof AppUsersListChar123IdChar125Route
  '/smp/serviceMap': typeof AppSmpServiceMapIndexRoute
  '/alerts/$vrn/$protectionType/edit': typeof AppAlertsVrnProtectionTypeEditRoute
  '/smp/accounts/$customerId/add': typeof AppSmpAccountsCustomerIdAddRoute
  '/smp/serviceMap/device/$deviceId': typeof AppSmpServiceMapDeviceDeviceIdRoute
  '/smp/webhooks/$webhookId/edit': typeof AppSmpWebhooksWebhookIdEditRoute
  '/smp/accounts/$customerId/$subscriptionId/edit': typeof AppSmpAccountsCustomerIdSubscriptionIdEditRoute
  '/smp/webhooks/$webhookId/secrets/create': typeof AppSmpWebhooksWebhookIdSecretsCreateRoute
  '/smp/webhooks/$webhookId/secrets/$secretId/edit': typeof AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_redirects': typeof RedirectsRouteWithChildren
  '/_app/smp': typeof AppSmpRouteRouteWithChildren
  '/_app/users': typeof AppUsersRouteRouteWithChildren
  '/_app/api-keys': typeof AppApiKeysRoute
  '/_app/devices': typeof AppDevicesRouteWithChildren
  '/_app/impacts': typeof AppImpactsRouteWithChildren
  '/_app/measurements': typeof AppMeasurementsRouteWithChildren
  '/_app/subscription': typeof AppSubscriptionRoute
  '/_public/login': typeof PublicLoginRoute
  '/_redirects/asset': typeof RedirectsAssetRoute
  '/_app/': typeof AppIndexRoute
  '/_app/alerts/add': typeof AppAlertsAddRoute
  '/_app/assets/add': typeof AppAssetsAddRoute
  '/_app/devices/$id': typeof AppDevicesIdRoute
  '/_app/devices/add': typeof AppDevicesAddRoute
  '/_app/impacts/$id': typeof AppImpactsIdRoute
  '/_app/m/_mobile': typeof AppMMobileRouteWithChildren
  '/_app/measurements/$id': typeof AppMeasurementsIdRoute
  '/_app/reports/add': typeof AppReportsAddRoute
  '/_app/reports/csv': typeof AppReportsCsvRoute
  '/_app/smp/accounts': typeof AppSmpAccountsRouteWithChildren
  '/_app/smp/serviceMap': typeof AppSmpServiceMapRouteWithChildren
  '/_app/smp/webRelays': typeof AppSmpWebRelaysRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/users/add': typeof AppUsersAddRoute
  '/_app/wind/add': typeof AppWindAddRoute
  '/_public/auth/error': typeof PublicAuthErrorRoute
  '/_public/optin/$secret': typeof PublicOptinSecretRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
  '/_app/impacts/': typeof AppImpactsIndexRoute
  '/_app/m/': typeof AppMIndexRoute
  '/_app/measurements/': typeof AppMeasurementsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/assets/$id_/edit': typeof AppAssetsIdEditRoute
  '/_app/devices/$id_/edit': typeof AppDevicesIdEditRoute
  '/_app/m/_mobile/locations': typeof AppMMobileLocationsRoute
  '/_app/m/_mobile/map': typeof AppMMobileMapRoute
  '/_app/m/_mobile/preferences': typeof AppMMobilePreferencesRoute
  '/_app/reports/hail/$id': typeof AppReportsHailIdRoute
  '/_app/reports/lightning/$id': typeof AppReportsLightningIdRoute
  '/_app/smp/accounts/$customerId': typeof AppSmpAccountsCustomerIdRouteWithChildren
  '/_app/smp/webhooks/create': typeof AppSmpWebhooksCreateRoute
  '/_app/smp/webhooks/{-$webhookId}': typeof AppSmpWebhooksChar123WebhookIdChar125Route
  '/_app/users/list/{-$id}': typeof AppUsersListChar123IdChar125Route
  '/_app/smp/serviceMap/': typeof AppSmpServiceMapIndexRoute
  '/_app/alerts_/$vrn/$protectionType/edit': typeof AppAlertsVrnProtectionTypeEditRoute
  '/_app/smp/accounts/$customerId/add': typeof AppSmpAccountsCustomerIdAddRoute
  '/_app/smp/serviceMap/device/$deviceId': typeof AppSmpServiceMapDeviceDeviceIdRoute
  '/_app/smp/webhooks/$webhookId/edit': typeof AppSmpWebhooksWebhookIdEditRoute
  '/_app/smp/accounts/$customerId/$subscriptionId/edit': typeof AppSmpAccountsCustomerIdSubscriptionIdEditRoute
  '/_app/smp/webhooks/$webhookId/secrets/create': typeof AppSmpWebhooksWebhookIdSecretsCreateRoute
  '/_app/smp/webhooks/$webhookId/secrets/$secretId/edit': typeof AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/smp'
    | '/users'
    | '/api-keys'
    | '/devices'
    | '/impacts'
    | '/measurements'
    | '/subscription'
    | '/login'
    | '/asset'
    | '/alerts/add'
    | '/assets/add'
    | '/devices/$id'
    | '/devices/add'
    | '/impacts/$id'
    | '/m'
    | '/measurements/$id'
    | '/reports/add'
    | '/reports/csv'
    | '/smp/accounts'
    | '/smp/serviceMap'
    | '/smp/webRelays'
    | '/users/$id'
    | '/users/add'
    | '/wind/add'
    | '/auth/error'
    | '/optin/$secret'
    | '/devices/'
    | '/impacts/'
    | '/m/'
    | '/measurements/'
    | '/reports/'
    | '/users/'
    | '/assets/$id/edit'
    | '/devices/$id/edit'
    | '/m/locations'
    | '/m/map'
    | '/m/preferences'
    | '/reports/hail/$id'
    | '/reports/lightning/$id'
    | '/smp/accounts/$customerId'
    | '/smp/webhooks/create'
    | '/smp/webhooks/{-$webhookId}'
    | '/users/list/{-$id}'
    | '/smp/serviceMap/'
    | '/alerts/$vrn/$protectionType/edit'
    | '/smp/accounts/$customerId/add'
    | '/smp/serviceMap/device/$deviceId'
    | '/smp/webhooks/$webhookId/edit'
    | '/smp/accounts/$customerId/$subscriptionId/edit'
    | '/smp/webhooks/$webhookId/secrets/create'
    | '/smp/webhooks/$webhookId/secrets/$secretId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/smp'
    | '/api-keys'
    | '/subscription'
    | '/login'
    | '/asset'
    | '/alerts/add'
    | '/assets/add'
    | '/devices/$id'
    | '/devices/add'
    | '/impacts/$id'
    | '/m'
    | '/measurements/$id'
    | '/reports/add'
    | '/reports/csv'
    | '/smp/accounts'
    | '/smp/webRelays'
    | '/users/$id'
    | '/users/add'
    | '/wind/add'
    | '/auth/error'
    | '/optin/$secret'
    | '/devices'
    | '/impacts'
    | '/measurements'
    | '/reports'
    | '/users'
    | '/assets/$id/edit'
    | '/devices/$id/edit'
    | '/m/locations'
    | '/m/map'
    | '/m/preferences'
    | '/reports/hail/$id'
    | '/reports/lightning/$id'
    | '/smp/accounts/$customerId'
    | '/smp/webhooks/create'
    | '/smp/webhooks/{-$webhookId}'
    | '/users/list/{-$id}'
    | '/smp/serviceMap'
    | '/alerts/$vrn/$protectionType/edit'
    | '/smp/accounts/$customerId/add'
    | '/smp/serviceMap/device/$deviceId'
    | '/smp/webhooks/$webhookId/edit'
    | '/smp/accounts/$customerId/$subscriptionId/edit'
    | '/smp/webhooks/$webhookId/secrets/create'
    | '/smp/webhooks/$webhookId/secrets/$secretId/edit'
  id:
    | '__root__'
    | '/_app'
    | '/_redirects'
    | '/_app/smp'
    | '/_app/users'
    | '/_app/api-keys'
    | '/_app/devices'
    | '/_app/impacts'
    | '/_app/measurements'
    | '/_app/subscription'
    | '/_public/login'
    | '/_redirects/asset'
    | '/_app/'
    | '/_app/alerts/add'
    | '/_app/assets/add'
    | '/_app/devices/$id'
    | '/_app/devices/add'
    | '/_app/impacts/$id'
    | '/_app/m/_mobile'
    | '/_app/measurements/$id'
    | '/_app/reports/add'
    | '/_app/reports/csv'
    | '/_app/smp/accounts'
    | '/_app/smp/serviceMap'
    | '/_app/smp/webRelays'
    | '/_app/users/$id'
    | '/_app/users/add'
    | '/_app/wind/add'
    | '/_public/auth/error'
    | '/_public/optin/$secret'
    | '/_app/devices/'
    | '/_app/impacts/'
    | '/_app/m/'
    | '/_app/measurements/'
    | '/_app/reports/'
    | '/_app/users/'
    | '/_app/assets/$id_/edit'
    | '/_app/devices/$id_/edit'
    | '/_app/m/_mobile/locations'
    | '/_app/m/_mobile/map'
    | '/_app/m/_mobile/preferences'
    | '/_app/reports/hail/$id'
    | '/_app/reports/lightning/$id'
    | '/_app/smp/accounts/$customerId'
    | '/_app/smp/webhooks/create'
    | '/_app/smp/webhooks/{-$webhookId}'
    | '/_app/users/list/{-$id}'
    | '/_app/smp/serviceMap/'
    | '/_app/alerts_/$vrn/$protectionType/edit'
    | '/_app/smp/accounts/$customerId/add'
    | '/_app/smp/serviceMap/device/$deviceId'
    | '/_app/smp/webhooks/$webhookId/edit'
    | '/_app/smp/accounts/$customerId/$subscriptionId/edit'
    | '/_app/smp/webhooks/$webhookId/secrets/create'
    | '/_app/smp/webhooks/$webhookId/secrets/$secretId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  RedirectsRoute: typeof RedirectsRouteWithChildren
  PublicLoginRoute: typeof PublicLoginRoute
  PublicAuthErrorRoute: typeof PublicAuthErrorRoute
  PublicOptinSecretRoute: typeof PublicOptinSecretRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_redirects': {
      id: '/_redirects'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof RedirectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-keys': {
      id: '/_app/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AppApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices': {
      id: '/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AppDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/impacts': {
      id: '/_app/impacts'
      path: '/impacts'
      fullPath: '/impacts'
      preLoaderRoute: typeof AppImpactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/measurements': {
      id: '/_app/measurements'
      path: '/measurements'
      fullPath: '/measurements'
      preLoaderRoute: typeof AppMeasurementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smp': {
      id: '/_app/smp'
      path: '/smp'
      fullPath: '/smp'
      preLoaderRoute: typeof AppSmpRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/subscription': {
      id: '/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AppSubscriptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_redirects/asset': {
      id: '/_redirects/asset'
      path: '/asset'
      fullPath: '/asset'
      preLoaderRoute: typeof RedirectsAssetRouteImport
      parentRoute: typeof RedirectsRoute
    }
    '/_app/alerts/add': {
      id: '/_app/alerts/add'
      path: '/alerts/add'
      fullPath: '/alerts/add'
      preLoaderRoute: typeof AppAlertsAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assets/add': {
      id: '/_app/assets/add'
      path: '/assets/add'
      fullPath: '/assets/add'
      preLoaderRoute: typeof AppAssetsAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/devices/$id': {
      id: '/_app/devices/$id'
      path: '/$id'
      fullPath: '/devices/$id'
      preLoaderRoute: typeof AppDevicesIdRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/devices/add': {
      id: '/_app/devices/add'
      path: '/add'
      fullPath: '/devices/add'
      preLoaderRoute: typeof AppDevicesAddRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/impacts/': {
      id: '/_app/impacts/'
      path: '/'
      fullPath: '/impacts/'
      preLoaderRoute: typeof AppImpactsIndexRouteImport
      parentRoute: typeof AppImpactsRoute
    }
    '/_app/impacts/$id': {
      id: '/_app/impacts/$id'
      path: '/$id'
      fullPath: '/impacts/$id'
      preLoaderRoute: typeof AppImpactsIdRouteImport
      parentRoute: typeof AppImpactsRoute
    }
    '/_app/m/': {
      id: '/_app/m/'
      path: '/m'
      fullPath: '/m/'
      preLoaderRoute: typeof AppMIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/m/_mobile': {
      id: '/_app/m/_mobile'
      path: '/m'
      fullPath: '/m'
      preLoaderRoute: typeof AppMMobileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/measurements/': {
      id: '/_app/measurements/'
      path: '/'
      fullPath: '/measurements/'
      preLoaderRoute: typeof AppMeasurementsIndexRouteImport
      parentRoute: typeof AppMeasurementsRoute
    }
    '/_app/measurements/$id': {
      id: '/_app/measurements/$id'
      path: '/$id'
      fullPath: '/measurements/$id'
      preLoaderRoute: typeof AppMeasurementsIdRouteImport
      parentRoute: typeof AppMeasurementsRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/add': {
      id: '/_app/reports/add'
      path: '/reports/add'
      fullPath: '/reports/add'
      preLoaderRoute: typeof AppReportsAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/csv': {
      id: '/_app/reports/csv'
      path: '/reports/csv'
      fullPath: '/reports/csv'
      preLoaderRoute: typeof AppReportsCsvRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smp/accounts': {
      id: '/_app/smp/accounts'
      path: '/accounts'
      fullPath: '/smp/accounts'
      preLoaderRoute: typeof AppSmpAccountsRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/smp/serviceMap': {
      id: '/_app/smp/serviceMap'
      path: '/serviceMap'
      fullPath: '/smp/serviceMap'
      preLoaderRoute: typeof AppSmpServiceMapRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/smp/webRelays': {
      id: '/_app/smp/webRelays'
      path: '/webRelays'
      fullPath: '/smp/webRelays'
      preLoaderRoute: typeof AppSmpWebRelaysRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/add': {
      id: '/_app/users/add'
      path: '/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AppUsersAddRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/wind/add': {
      id: '/_app/wind/add'
      path: '/wind/add'
      fullPath: '/wind/add'
      preLoaderRoute: typeof AppWindAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/auth/error': {
      id: '/_public/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof PublicAuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/optin/$secret': {
      id: '/_public/optin/$secret'
      path: '/optin/$secret'
      fullPath: '/optin/$secret'
      preLoaderRoute: typeof PublicOptinSecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/assets/$id_/edit': {
      id: '/_app/assets/$id_/edit'
      path: '/assets/$id/edit'
      fullPath: '/assets/$id/edit'
      preLoaderRoute: typeof AppAssetsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$id_/edit': {
      id: '/_app/devices/$id_/edit'
      path: '/$id/edit'
      fullPath: '/devices/$id/edit'
      preLoaderRoute: typeof AppDevicesIdEditRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/m/_mobile/locations': {
      id: '/_app/m/_mobile/locations'
      path: '/locations'
      fullPath: '/m/locations'
      preLoaderRoute: typeof AppMMobileLocationsRouteImport
      parentRoute: typeof AppMMobileRoute
    }
    '/_app/m/_mobile/map': {
      id: '/_app/m/_mobile/map'
      path: '/map'
      fullPath: '/m/map'
      preLoaderRoute: typeof AppMMobileMapRouteImport
      parentRoute: typeof AppMMobileRoute
    }
    '/_app/m/_mobile/preferences': {
      id: '/_app/m/_mobile/preferences'
      path: '/preferences'
      fullPath: '/m/preferences'
      preLoaderRoute: typeof AppMMobilePreferencesRouteImport
      parentRoute: typeof AppMMobileRoute
    }
    '/_app/reports/hail/$id': {
      id: '/_app/reports/hail/$id'
      path: '/reports/hail/$id'
      fullPath: '/reports/hail/$id'
      preLoaderRoute: typeof AppReportsHailIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/lightning/$id': {
      id: '/_app/reports/lightning/$id'
      path: '/reports/lightning/$id'
      fullPath: '/reports/lightning/$id'
      preLoaderRoute: typeof AppReportsLightningIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smp/accounts/$customerId': {
      id: '/_app/smp/accounts/$customerId'
      path: '/$customerId'
      fullPath: '/smp/accounts/$customerId'
      preLoaderRoute: typeof AppSmpAccountsCustomerIdRouteImport
      parentRoute: typeof AppSmpAccountsRoute
    }
    '/_app/smp/serviceMap/': {
      id: '/_app/smp/serviceMap/'
      path: '/'
      fullPath: '/smp/serviceMap/'
      preLoaderRoute: typeof AppSmpServiceMapIndexRouteImport
      parentRoute: typeof AppSmpServiceMapRoute
    }
    '/_app/smp/webhooks/create': {
      id: '/_app/smp/webhooks/create'
      path: '/webhooks/create'
      fullPath: '/smp/webhooks/create'
      preLoaderRoute: typeof AppSmpWebhooksCreateRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/smp/webhooks/{-$webhookId}': {
      id: '/_app/smp/webhooks/{-$webhookId}'
      path: '/webhooks/{-$webhookId}'
      fullPath: '/smp/webhooks/{-$webhookId}'
      preLoaderRoute: typeof AppSmpWebhooksChar123WebhookIdChar125RouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/users/list/{-$id}': {
      id: '/_app/users/list/{-$id}'
      path: '/list/{-$id}'
      fullPath: '/users/list/{-$id}'
      preLoaderRoute: typeof AppUsersListChar123IdChar125RouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/alerts_/$vrn/$protectionType/edit': {
      id: '/_app/alerts_/$vrn/$protectionType/edit'
      path: '/alerts/$vrn/$protectionType/edit'
      fullPath: '/alerts/$vrn/$protectionType/edit'
      preLoaderRoute: typeof AppAlertsVrnProtectionTypeEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smp/accounts/$customerId/add': {
      id: '/_app/smp/accounts/$customerId/add'
      path: '/add'
      fullPath: '/smp/accounts/$customerId/add'
      preLoaderRoute: typeof AppSmpAccountsCustomerIdAddRouteImport
      parentRoute: typeof AppSmpAccountsCustomerIdRoute
    }
    '/_app/smp/serviceMap/device/$deviceId': {
      id: '/_app/smp/serviceMap/device/$deviceId'
      path: '/device/$deviceId'
      fullPath: '/smp/serviceMap/device/$deviceId'
      preLoaderRoute: typeof AppSmpServiceMapDeviceDeviceIdRouteImport
      parentRoute: typeof AppSmpServiceMapRoute
    }
    '/_app/smp/webhooks/$webhookId/edit': {
      id: '/_app/smp/webhooks/$webhookId/edit'
      path: '/webhooks/$webhookId/edit'
      fullPath: '/smp/webhooks/$webhookId/edit'
      preLoaderRoute: typeof AppSmpWebhooksWebhookIdEditRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/smp/accounts/$customerId/$subscriptionId/edit': {
      id: '/_app/smp/accounts/$customerId/$subscriptionId/edit'
      path: '/$subscriptionId/edit'
      fullPath: '/smp/accounts/$customerId/$subscriptionId/edit'
      preLoaderRoute: typeof AppSmpAccountsCustomerIdSubscriptionIdEditRouteImport
      parentRoute: typeof AppSmpAccountsCustomerIdRoute
    }
    '/_app/smp/webhooks/$webhookId/secrets/create': {
      id: '/_app/smp/webhooks/$webhookId/secrets/create'
      path: '/webhooks/$webhookId/secrets/create'
      fullPath: '/smp/webhooks/$webhookId/secrets/create'
      preLoaderRoute: typeof AppSmpWebhooksWebhookIdSecretsCreateRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
    '/_app/smp/webhooks/$webhookId/secrets/$secretId/edit': {
      id: '/_app/smp/webhooks/$webhookId/secrets/$secretId/edit'
      path: '/webhooks/$webhookId/secrets/$secretId/edit'
      fullPath: '/smp/webhooks/$webhookId/secrets/$secretId/edit'
      preLoaderRoute: typeof AppSmpWebhooksWebhookIdSecretsSecretIdEditRouteImport
      parentRoute: typeof AppSmpRouteRoute
    }
  }
}

interface AppSmpAccountsCustomerIdRouteChildren {
  AppSmpAccountsCustomerIdAddRoute: typeof AppSmpAccountsCustomerIdAddRoute
  AppSmpAccountsCustomerIdSubscriptionIdEditRoute: typeof AppSmpAccountsCustomerIdSubscriptionIdEditRoute
}

const AppSmpAccountsCustomerIdRouteChildren: AppSmpAccountsCustomerIdRouteChildren =
  {
    AppSmpAccountsCustomerIdAddRoute: AppSmpAccountsCustomerIdAddRoute,
    AppSmpAccountsCustomerIdSubscriptionIdEditRoute:
      AppSmpAccountsCustomerIdSubscriptionIdEditRoute,
  }

const AppSmpAccountsCustomerIdRouteWithChildren =
  AppSmpAccountsCustomerIdRoute._addFileChildren(
    AppSmpAccountsCustomerIdRouteChildren,
  )

interface AppSmpAccountsRouteChildren {
  AppSmpAccountsCustomerIdRoute: typeof AppSmpAccountsCustomerIdRouteWithChildren
}

const AppSmpAccountsRouteChildren: AppSmpAccountsRouteChildren = {
  AppSmpAccountsCustomerIdRoute: AppSmpAccountsCustomerIdRouteWithChildren,
}

const AppSmpAccountsRouteWithChildren = AppSmpAccountsRoute._addFileChildren(
  AppSmpAccountsRouteChildren,
)

interface AppSmpServiceMapRouteChildren {
  AppSmpServiceMapIndexRoute: typeof AppSmpServiceMapIndexRoute
  AppSmpServiceMapDeviceDeviceIdRoute: typeof AppSmpServiceMapDeviceDeviceIdRoute
}

const AppSmpServiceMapRouteChildren: AppSmpServiceMapRouteChildren = {
  AppSmpServiceMapIndexRoute: AppSmpServiceMapIndexRoute,
  AppSmpServiceMapDeviceDeviceIdRoute: AppSmpServiceMapDeviceDeviceIdRoute,
}

const AppSmpServiceMapRouteWithChildren =
  AppSmpServiceMapRoute._addFileChildren(AppSmpServiceMapRouteChildren)

interface AppSmpRouteRouteChildren {
  AppSmpAccountsRoute: typeof AppSmpAccountsRouteWithChildren
  AppSmpServiceMapRoute: typeof AppSmpServiceMapRouteWithChildren
  AppSmpWebRelaysRoute: typeof AppSmpWebRelaysRoute
  AppSmpWebhooksCreateRoute: typeof AppSmpWebhooksCreateRoute
  AppSmpWebhooksChar123WebhookIdChar125Route: typeof AppSmpWebhooksChar123WebhookIdChar125Route
  AppSmpWebhooksWebhookIdEditRoute: typeof AppSmpWebhooksWebhookIdEditRoute
  AppSmpWebhooksWebhookIdSecretsCreateRoute: typeof AppSmpWebhooksWebhookIdSecretsCreateRoute
  AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute: typeof AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute
}

const AppSmpRouteRouteChildren: AppSmpRouteRouteChildren = {
  AppSmpAccountsRoute: AppSmpAccountsRouteWithChildren,
  AppSmpServiceMapRoute: AppSmpServiceMapRouteWithChildren,
  AppSmpWebRelaysRoute: AppSmpWebRelaysRoute,
  AppSmpWebhooksCreateRoute: AppSmpWebhooksCreateRoute,
  AppSmpWebhooksChar123WebhookIdChar125Route:
    AppSmpWebhooksChar123WebhookIdChar125Route,
  AppSmpWebhooksWebhookIdEditRoute: AppSmpWebhooksWebhookIdEditRoute,
  AppSmpWebhooksWebhookIdSecretsCreateRoute:
    AppSmpWebhooksWebhookIdSecretsCreateRoute,
  AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute:
    AppSmpWebhooksWebhookIdSecretsSecretIdEditRoute,
}

const AppSmpRouteRouteWithChildren = AppSmpRouteRoute._addFileChildren(
  AppSmpRouteRouteChildren,
)

interface AppUsersRouteRouteChildren {
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppUsersAddRoute: typeof AppUsersAddRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppUsersListChar123IdChar125Route: typeof AppUsersListChar123IdChar125Route
}

const AppUsersRouteRouteChildren: AppUsersRouteRouteChildren = {
  AppUsersIdRoute: AppUsersIdRoute,
  AppUsersAddRoute: AppUsersAddRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppUsersListChar123IdChar125Route: AppUsersListChar123IdChar125Route,
}

const AppUsersRouteRouteWithChildren = AppUsersRouteRoute._addFileChildren(
  AppUsersRouteRouteChildren,
)

interface AppDevicesRouteChildren {
  AppDevicesIdRoute: typeof AppDevicesIdRoute
  AppDevicesAddRoute: typeof AppDevicesAddRoute
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
  AppDevicesIdEditRoute: typeof AppDevicesIdEditRoute
}

const AppDevicesRouteChildren: AppDevicesRouteChildren = {
  AppDevicesIdRoute: AppDevicesIdRoute,
  AppDevicesAddRoute: AppDevicesAddRoute,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
  AppDevicesIdEditRoute: AppDevicesIdEditRoute,
}

const AppDevicesRouteWithChildren = AppDevicesRoute._addFileChildren(
  AppDevicesRouteChildren,
)

interface AppImpactsRouteChildren {
  AppImpactsIdRoute: typeof AppImpactsIdRoute
  AppImpactsIndexRoute: typeof AppImpactsIndexRoute
}

const AppImpactsRouteChildren: AppImpactsRouteChildren = {
  AppImpactsIdRoute: AppImpactsIdRoute,
  AppImpactsIndexRoute: AppImpactsIndexRoute,
}

const AppImpactsRouteWithChildren = AppImpactsRoute._addFileChildren(
  AppImpactsRouteChildren,
)

interface AppMeasurementsRouteChildren {
  AppMeasurementsIdRoute: typeof AppMeasurementsIdRoute
  AppMeasurementsIndexRoute: typeof AppMeasurementsIndexRoute
}

const AppMeasurementsRouteChildren: AppMeasurementsRouteChildren = {
  AppMeasurementsIdRoute: AppMeasurementsIdRoute,
  AppMeasurementsIndexRoute: AppMeasurementsIndexRoute,
}

const AppMeasurementsRouteWithChildren = AppMeasurementsRoute._addFileChildren(
  AppMeasurementsRouteChildren,
)

interface AppMMobileRouteChildren {
  AppMMobileLocationsRoute: typeof AppMMobileLocationsRoute
  AppMMobileMapRoute: typeof AppMMobileMapRoute
  AppMMobilePreferencesRoute: typeof AppMMobilePreferencesRoute
}

const AppMMobileRouteChildren: AppMMobileRouteChildren = {
  AppMMobileLocationsRoute: AppMMobileLocationsRoute,
  AppMMobileMapRoute: AppMMobileMapRoute,
  AppMMobilePreferencesRoute: AppMMobilePreferencesRoute,
}

const AppMMobileRouteWithChildren = AppMMobileRoute._addFileChildren(
  AppMMobileRouteChildren,
)

interface AppRouteChildren {
  AppSmpRouteRoute: typeof AppSmpRouteRouteWithChildren
  AppUsersRouteRoute: typeof AppUsersRouteRouteWithChildren
  AppApiKeysRoute: typeof AppApiKeysRoute
  AppDevicesRoute: typeof AppDevicesRouteWithChildren
  AppImpactsRoute: typeof AppImpactsRouteWithChildren
  AppMeasurementsRoute: typeof AppMeasurementsRouteWithChildren
  AppSubscriptionRoute: typeof AppSubscriptionRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAlertsAddRoute: typeof AppAlertsAddRoute
  AppAssetsAddRoute: typeof AppAssetsAddRoute
  AppMMobileRoute: typeof AppMMobileRouteWithChildren
  AppReportsAddRoute: typeof AppReportsAddRoute
  AppReportsCsvRoute: typeof AppReportsCsvRoute
  AppWindAddRoute: typeof AppWindAddRoute
  AppMIndexRoute: typeof AppMIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppAssetsIdEditRoute: typeof AppAssetsIdEditRoute
  AppReportsHailIdRoute: typeof AppReportsHailIdRoute
  AppReportsLightningIdRoute: typeof AppReportsLightningIdRoute
  AppAlertsVrnProtectionTypeEditRoute: typeof AppAlertsVrnProtectionTypeEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSmpRouteRoute: AppSmpRouteRouteWithChildren,
  AppUsersRouteRoute: AppUsersRouteRouteWithChildren,
  AppApiKeysRoute: AppApiKeysRoute,
  AppDevicesRoute: AppDevicesRouteWithChildren,
  AppImpactsRoute: AppImpactsRouteWithChildren,
  AppMeasurementsRoute: AppMeasurementsRouteWithChildren,
  AppSubscriptionRoute: AppSubscriptionRoute,
  AppIndexRoute: AppIndexRoute,
  AppAlertsAddRoute: AppAlertsAddRoute,
  AppAssetsAddRoute: AppAssetsAddRoute,
  AppMMobileRoute: AppMMobileRouteWithChildren,
  AppReportsAddRoute: AppReportsAddRoute,
  AppReportsCsvRoute: AppReportsCsvRoute,
  AppWindAddRoute: AppWindAddRoute,
  AppMIndexRoute: AppMIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppAssetsIdEditRoute: AppAssetsIdEditRoute,
  AppReportsHailIdRoute: AppReportsHailIdRoute,
  AppReportsLightningIdRoute: AppReportsLightningIdRoute,
  AppAlertsVrnProtectionTypeEditRoute: AppAlertsVrnProtectionTypeEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface RedirectsRouteChildren {
  RedirectsAssetRoute: typeof RedirectsAssetRoute
}

const RedirectsRouteChildren: RedirectsRouteChildren = {
  RedirectsAssetRoute: RedirectsAssetRoute,
}

const RedirectsRouteWithChildren = RedirectsRoute._addFileChildren(
  RedirectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  RedirectsRoute: RedirectsRouteWithChildren,
  PublicLoginRoute: PublicLoginRoute,
  PublicAuthErrorRoute: PublicAuthErrorRoute,
  PublicOptinSecretRoute: PublicOptinSecretRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
